/**
 * 業務フロー（F2）の Query キー。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 業務フロー・ステージの図・案件が変えた業務フローの一覧の読取 procedure の Query キーを定義する。
 * @graph-connects none
 */
import type { LocaleKeyPart } from './common.js';

/** 業務フローの仕様グラフ読取のキー。 @graph-connects none */
export const flowQueryKeys = {
  /*
   * 業務フロー 1 本、またはステージの図。何で引いたか（flow / stage）・id・案件・面・言語を載せる。
   * 案件番号と面まで載せないと「現在版」と「その案件が触る直前の版」が同じキーの下で相手を
   * 上書きし、左右比較の 2 枚に同じ図が並ぶ。flow と stage は id の空間が違うので区別する。
   */
  getFlow: (
    target: 'flow' | 'stage',
    id: number,
    locale: LocaleKeyPart,
    pjNumber?: number,
    side?: string,
  ) =>
    ['specGraph', 'getFlow', target, id, pjNumber ?? null, side ?? null, locale ?? null] as const,
  /* 案件が変えた業務フローの一覧。 */
  listPjFlows: (pjNumber: number, locale: LocaleKeyPart) =>
    ['specGraph', 'listPjFlows', pjNumber, locale ?? null] as const,
} as const;
